import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withJsScript from 'client/helpers/withJsScript';
import SrBox from 'client/components/SrBox';
import SrLink from 'client/components/SrLink/SrLink';

@withJsScript({
  scriptUrl: 'https://unpkg.com/leaflet@1.6.0/dist/leaflet-src.js',
})
class SrOpenStreetMap extends Component {
  static propTypes = {
    coordinates: PropTypes.array.isRequired,
    initialZoom: PropTypes.number,
    onMapClick: PropTypes.func,
  };

  static defaultProps = {
    initialZoom: 12,
  };

  static displayName = 'SrOpenStreetMap';

  render() {
    if (!process.browser) {
      return null;
    }

    const { coordinates, initialZoom, onMapClick } = this.props;
    const lng = coordinates[0];
    const lat = coordinates[1];
    const position = [lat, lng];
    const googleStreetUrl = `http://maps.google.com/maps?q=&layer=c&cbll=${lat},${lng}&cbp=11,0,0,0,0`;

    const { Map, TileLayer, Marker } = require('react-leaflet');

    return (
      <div className="section map">
        <SrBox
          width="100%"
          height="100%"
          minHeight="400px"
          borderRadius="8px"
          overflow="hidden"
          position="relative"
          zIndex="800"
        >
          <Map
            center={position}
            zoom={initialZoom}
            style={{
              height: '100%',
              width: '100%',
              minHeight: '400px',
            }}
            onClick={onMapClick}
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={position} />
          </Map>
          <SrLink
            weight="bold"
            font="whitney-sc"
            color="blue300"
            cursor="pointer"
            decoration="underline"
            to={googleStreetUrl}
            target="_blank"
          >
            View on Google Street View 📍
          </SrLink>
        </SrBox>
      </div>
    );
  }
}

export default SrOpenStreetMap;
